<div
  class="menu pt-4 d-column expanded"
  (mouseover)="isExpanded = true"
  (mouseout)="isExpanded = false"
  [class.expanded]="fixed ? fixed : isExpanded"
>
  <div class="logo d-row align-items-center">
    <img class="my-3 mx-5" src="/assets/images/logo-menu.jpg" width="32px" height="32px" />
    <span class="heading-3 item-menu-link">Content Studio</span>
  </div>

  <div class="logo d-row align-items-center">
    <small class="mx-5">{{ envName }}</small>
  </div>

  <div class="line m-5 my-2"></div>

  @for (item of menuItems; track item) {
    <a class="item-menu d-column c-pointer pe-4 mb-1" (click)="clickMenu($event, item)">
      <div class="d-row align-items-center">
        <div class="d-row align-items-center">
          <lib-elux-icon
            class="p-3 mx-3 icon-menu"
            [icon]="item.icon"
            [color]="'#011E41'"
            [size]="'24'"
            [sizeType]="'px'"
            [class.active]="item.isActive"
            [class.open]="item.isOpen"
          />
          <span class="subtitle-1 item-menu-link c-blue">{{ item.name }}</span>
        </div>
        @if (item.subMenus.length > 1) {
          <img
            [src]="'/assets/icons/' + (item.isOpen ? 'Chevron_Up.svg' : 'Chevron_Down.svg')"
            width="24px"
            height="24px"
          />
        }
      </div>
      @if (item.isOpen && item.subMenus.length > 1) {
        <div class="sub-menus d-column ps-7 ms-5 mb-4">
          @for (subItem of item.subMenus; track subItem) {
            <a class="subtitle-1 item-submenu mt-4" [routerLink]="subItem.link" (click)="$event.stopPropagation()">
              {{ subItem.name }}
            </a>
          }
        </div>
      }
    </a>
  }

  @if (isExpanded || fixed) {
    <div class="justify-content-center mt-2 d-row align-items-center">
      <span class="subtitle-1">Fixar menu</span>
      <lib-elux-switch [checked]="fixed" size="small" (onChange)="onChange($event)" />
    </div>
  }
</div>
